module.exports = __webpack_public_path__ + "img/coin.fa119dbc.svg";